let setIntervalId;

export const hideLoader = () => {
  clearInterval(setIntervalId);
  const ele = document.querySelectorAll('#loader');
  if (ele && ele.length > 0) {
    ele.forEach((item) => {
      const loader = item;
      loader.style.display = 'none';
    });
  }
};

export const showLoader = () => {
  try {
    const ele = document.getElementById('loader');
    clearInterval(setIntervalId);
    if (ele) {
      if (ele.style.display === 'block') {
        const loaderContent = document.querySelector('.content_update_loading');
        if (loaderContent) {
          loaderContent.ariaLabel = 'content is loading';
        }
        // Performance improve and avoids calling focusTrap.activate() twice;
        return;
      }
      ele.style.display = 'block';
    } else {
      const injectLoader = document.createElement('div');
      injectLoader.setAttribute('id', 'loader');
      injectLoader.setAttribute('aria-label', 'loader overlay');
      injectLoader.setAttribute('class', 'loaderOverlay');
      injectLoader.setAttribute('role', 'alert');
      injectLoader.setAttribute('aria-live', 'assertive');
      injectLoader.innerHTML = '<div class="loader"></div><div class="content_update_loading"></div>';
      document.body.appendChild(injectLoader);
      const loaderContent = document.querySelector('.content_update_loading');
      if (loaderContent) {
        loaderContent.ariaLabel = 'content is loading';
      }
    }
    setIntervalId = setInterval(() => {
      const loaderContent = document.querySelector('.content_update_loading');
      if (loaderContent) {
        loaderContent.innerHTML = '';
        setTimeout(() => {
          loaderContent.ariaLabel = 'still loading';
        }, 1000);
      } else {
        clearInterval(setIntervalId);
      }
    }, 60000);
  } catch (e) {
    console.log(e);
  }
};

export const hideHTMLLoader = () => {
  clearInterval(setIntervalId);
  const ele = document.getElementById('loader');
  if (ele) {
    ele.style.display = 'none';
  }
};
